'use strict';

var React = require('react');

var SvgMetaobjectReferenceIcon = function SvgMetaobjectReferenceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.25 4v1h-1.5v-1h1.5Zm1.5-.5v1.5h.5c.552 0 1 .448 1 1v5.25c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-.25h-12v3.75h5.5c.414 0 .75.336.75.75s-.336.75-.75.75h-6c-.552 0-1-.448-1-1v-4.75c0-.552.448-1 1-1h.5v-1.5c0-.552.448-1 1-1h2.5c.552 0 1 .448 1 1v1.5h1.5v-3.5c0-.552.448-1 1-1h.5v-1.5c0-.552.448-1 1-1h2.5c.552 0 1 .448 1 1Zm-4.5 3h4.5v3h-4.5v-3Zm-6 3h1.5v-1h-1.5v1Zm9.5 5.5c.69 0 1.25.56 1.25 1.25v.5c0 .414.336.75.75.75s.75-.336.75-.75v-.5c0-1.519-1.231-2.75-2.75-2.75h-1.44l.47-.47c.293-.293.293-.767 0-1.06-.293-.293-.767-.293-1.06 0l-1.75 1.75c-.141.14-.22.331-.22.53s.079.39.22.53l1.75 1.75c.293.293.767.293 1.06 0 .293-.293.293-.767 0-1.06l-.47-.47h1.44Z"
  }));
};
SvgMetaobjectReferenceIcon.displayName = "MetaobjectReferenceIcon";

exports.SvgMetaobjectReferenceIcon = SvgMetaobjectReferenceIcon;
